module.exports = __webpack_public_path__ + "static/media/ye.b45153c6.svg";